import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'capitalize'
})
export class CapitalizePipe implements PipeTransform {
  transform(value: string): string {
    if (value) {
      value = value.toLowerCase();
      return value.replace(/\b\w/g, (char) => char.toUpperCase());
    }
  }
}
